import { validateResponse, checkResponseError } from "../lib/validateResponse";
import { oneError, ValidationErrors } from "../lib/validationAllFields";
import {
  VALIDATE_FORM_FIELD,
  VALIDATE_FORM_FIELD_SUCCESS,
  VALIDATE_FORM_FIELD_ERROR
} from "../lib/formsReducer";
import { SET_ENTIIY_FIELD, SER_SEARCH_FIELD } from "../lib/entitiesReducer";
import { normalize, arrayOf } from "normalizr";
import { fieldCategoryTranslation, section } from "../app/schema";

export const POST_FIELD_CATEGORIES_TRANSLATIONS = "POST_FIELD_CATEGORIES_TRANSLATIONS";
export const POST_FIELD_CATEGORIES_TRANSLATIONS_SUCCESS = "POST_FIELD_CATEGORIES_TRANSLATIONS_SUCCESS";
export const POST_FIELD_CATEGORIES_TRANSLATIONS_ERROR = "POST_FIELD_CATEGORIES_TRANSLATIONS_ERROR";

export const PATCH_FIELD_CATEGORIES_TRANSLATION = "PATCH_FIELD_CATEGORIES_TRANSLATION";
export const PATCH_FIELD_CATEGORIES_TRANSLATION_SUCCESS = "PATCH_FIELD_CATEGORIES_TRANSLATION_SUCCESS";
export const PATCH_FIELD_CATEGORIES_TRANSLATION_ERROR = "PATCH_FIELD_CATEGORIES_TRANSLATION_ERROR";

export const DELETE_FIELD_CATEGORIES_TRANSLATION = "DELETE_FIELD_CATEGORIES_TRANSLATION";
export const DELETE_FIELD_CATEGORIES_TRANSLATION_SUCCESS = "DELETE_FIELD_CATEGORIES_TRANSLATION_SUCCESS";
export const DELETE_FIELD_CATEGORIES_TRANSLATION_ERROR = "DELETE_FIELD_CATEGORIES_TRANSLATION_ERROR";

export const GET_FIELD_CATEGORIES_TRANSLATION_SECTIONS = "GET_FIELD_CATEGORIES_TRANSLATION_SECTIONS";
export const GET_FIELD_CATEGORIES_TRANSLATION_SECTIONS_SUCCESS = "GET_FIELD_CATEGORIES_TRANSLATION_SECTIONS_SUCCESS";
export const GET_FIELD_CATEGORIES_TRANSLATION_SECTIONS_ERROR = "GET_FIELD_CATEGORIES_TRANSLATION_SECTIONS_ERROR";

export const POST_FIELD_CATEGORIES_TRANSLATION_SECTION = "POST_FIELD_CATEGORIES_TRANSLATION_SECTION";
export const POST_FIELD_CATEGORIES_TRANSLATION_SECTION_SUCCESS = "POST_FIELD_CATEGORIES_TRANSLATION_SECTION_SUCCESS";
export const POST_FIELD_CATEGORIES_TRANSLATION_SECTION_ERROR = "POST_FIELD_CATEGORIES_TRANSLATION_SECTION_ERROR";

export const SET_IS_ADD_FIELD_CATEGORY_TRANSLATION_MODAL_VISIBLE = "SET_IS_ADD_FIELD_CATEGORY_TRANSLATION_MODAL_VISIBLE";
export const SET_IS_ADD_FIELD_CATEGORY_TRANSLATION_SECTION_MODAL_VISIBLE = "SET_IS_ADD_FIELD_CATEGORY_TRANSLATION_SECTION_MODAL_VISIBLE";

// Validation
const validateForm = {
  createFieldCategoriesTranslation: (validate, fields, oneField) => validate(
    fields,
    oneField
  )// .prop('name', 'Nazwa').required()
  .getErrors().promise,
  createFieldCategoriesTranslationSection: (validate, fields, oneField) =>
    validate(fields, oneField)// .prop('name', 'Nazwa').required()
    .getErrors().promise
};

// Requests

const postFieldCategoriesTranslations = (fetch, apiHost, accessToken, data) =>
  fetch(`${apiHost}/v1/field-categories-translations`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "POST"
  }).then(response => {
    return validateResponse(response, {});
  });

const patchFieldCategoriesTranslation = (
  fetch,
  apiHost,
  accessToken,
  uid,
  data
) =>
  fetch(`${apiHost}/v1/field-categories-translations/${uid}`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "PATCH"
  }).then(response => {
    return validateResponse(response, {});
  });

const deleteFieldCategoriesTranslation = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/field-categories-translations/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "DELETE"
  }).then(response => {
    return validateResponse(response, {
      validation_error: {
        msg: "Nie można usunąć danych pola tłumaczenia kategorii, ponieważ są one używane przez inne zasoby.",
        field: "all"
      }
    });
  });

const getFieldCategoriesTranslationsSectionsGet = (
  fetch,
  apiHost,
  accessToken,
  uid
) =>
  fetch(`${apiHost}/v1/field-categories-translations/${uid}/sections`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  }).then(response => {
    return validateResponse(response, {});
  });

const postFieldCategoriesTranslationsSection = (
  fetch,
  apiHost,
  accessToken,
  data,
  uid
) =>
  fetch(`${apiHost}/v1/field-categories-translations/${uid}/sections`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "POST"
  }).then(response => {
    return validateResponse(response, {});
  });

// Actions

export function createFieldCategoriesTranslation(data) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [POST_FIELD_CATEGORIES_TRANSLATIONS],
    payload: {
      promise: validateForm
        ["createFieldCategoriesTranslation"](validate, data)
        .then(() =>
          postFieldCategoriesTranslations(
            fetch,
            config().apiHost,
            users().viewer.accessToken,
            data
          ))
        .then(data => {
          return normalize(data, fieldCategoryTranslation);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function updateFormCategoriesTranslation(uid, data) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [PATCH_FIELD_CATEGORIES_TRANSLATION],
    payload: {
      promise: patchFieldCategoriesTranslation(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid,
        data
      )
        .then(data => {
          return normalize(data, fieldCategoryTranslation);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function removeFormCategoriesTranslation(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [DELETE_FIELD_CATEGORIES_TRANSLATION],
    payload: {
      promise: deleteFieldCategoriesTranslation(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      }),
      data: {
        uid
      }
    }
  });
}

export function getFieldCategoriesTranslationsSections(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [GET_FIELD_CATEGORIES_TRANSLATION_SECTIONS],
    payload: {
      promise: getFieldCategoriesTranslationsSectionsGet(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      )
        .then(data => {
          return normalize(data, arrayOf(section));
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function createFieldCategoriesTranslationSection(data, uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [POST_FIELD_CATEGORIES_TRANSLATION_SECTION],
    payload: {
      promise: validateForm
        ["createFieldCategoriesTranslationSection"](validate, data)
        .then(() =>
          postFieldCategoriesTranslationsSection(
            fetch,
            config().apiHost,
            users().viewer.accessToken,
            data,
            uid
          ))
        .then(data => {
          return normalize(data, section);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function setIsAddFieldCategoryTranslationModalVisible(value) {
  return {
    type: SET_IS_ADD_FIELD_CATEGORY_TRANSLATION_MODAL_VISIBLE,
    payload: {
      isVisible: value
    }
  };
}

export function setIsAddFieldCategoryTranslationSectionModalVisible(value) {
  return {
    type: SET_IS_ADD_FIELD_CATEGORY_TRANSLATION_SECTION_MODAL_VISIBLE,
    payload: {
      isVisible: value
    }
  };
}

// Standard functions
export function validateFormFieldFieldCategoriesTranslations(
  form,
  name,
  value
) {
  const feature = "fieldCategoriesTranslations";
  let fields = {};
  fields[name] = value;
  return ({ fetch, validate, config, users }) => ({
    type: [`${VALIDATE_FORM_FIELD}_${feature.toUpperCase()}`],
    payload: {
      promise: validateForm[form](validate, fields, true).catch(err => {
        let error = checkResponseError(err);
        throw error;
      })
    }
  });
}



// WEBPACK FOOTER //
// ./src/common/fieldCategoriesTranslations/actions.js